"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logAppEntry = logAppEntry;
var _browserLogs = require("@datadog/browser-logs");
/**
 * 
 * @param {string} userId 
 * @param {string} chimeUserId 
 * @param {string} chimeMeetingId 
 */
function logAppEntry(userId, chimeUserId, chimeMeetingId) {
  var messageContext = {
    logger: {
      name: 'studio-app-entry'
    }
  };
  var message = "User Entered. UserId: ".concat(userId, " Chime UserId: ").concat(chimeUserId, " Chime MeetingId: ").concat(chimeMeetingId);
  _browserLogs.datadogLogs.setGlobalContextProperty('studio.user.id', userId);
  _browserLogs.datadogLogs.setGlobalContextProperty('studio.meeting.id', chimeMeetingId);
  _browserLogs.datadogLogs.setGlobalContextProperty('studio.chime.user.id', chimeUserId);

  // setting these duplicate fields to help us align with some RUM metrics until WEBINAR-24489
  _browserLogs.datadogLogs.setGlobalContextProperty('userId', userId);
  _browserLogs.datadogLogs.setGlobalContextProperty('meetingId', chimeMeetingId);
  _browserLogs.datadogLogs.logger['info'](message, messageContext);
}